import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { CarouselComponent } from 'ngx-owl-carousel-o';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductDTO } from "../../../../../projects/tekkeys-common/src/lib/DTO/product.dto";

@Component({
  selector: 'app-carousel-home',
  templateUrl: './carousel-home.component.html',
  styleUrls: ['./carousel-home.component.scss'],
})
export class CarouselHomeComponent implements OnChanges, OnDestroy {
  @ViewChild('owlCar', { static: false }) owlCar: CarouselComponent | undefined;
  @Input() products: Observable<ProductDTO[]>;
  @Input() similarProducts: boolean = false;

  currentIndex = 1;
  len: number = 0;

  showArrowLeft = true;
  showArrowRight = true;

  defaultOptions = {
    loop: false,
    margin: 10,
    nav: false,
    mouseDrag: true,
    touchDrag: true,
    navSpeed: 200,
    pullDrag: true,
    slideBy: 3,
    dots: false,
    responsive: {
      0: { items: 2 },
      480: { items: 2 },
      768: { items: 3 },
      999: { items: 4 },
      1200: { items: 4 }
    }
  };

  customOptions = this.defaultOptions;

  private destroy$ = new Subject<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['products'] && this.products) {
      this.products
        .pipe(takeUntil(this.destroy$))
        .subscribe(productList => {
          this.len = productList.length;
          this.updateCarouselOptions(this.len);
          this.updateNavigationButtons();
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateCarouselOptions(productCount: number) {
    const width = window.innerWidth;

    this.customOptions = {
      ...this.defaultOptions,
      responsive: {
        0: { items: Math.min(productCount, 2) },
        480: { items: Math.min(productCount, 2) },
        768: { items: Math.min(productCount, 3) },
        999: { items: Math.min(productCount, 4) },
        1200: { items: Math.min(productCount, 4) }
      }
    };
  }

  getItemsPerPage(): number {
    const width = window.innerWidth;
    const breakpoints = this.customOptions.responsive;
    const sortedBreakpoints = Object.keys(breakpoints)
      .map(k => parseInt(k, 10))
      .sort((a, b) => a - b);

    let items = 1;
    for (const bp of sortedBreakpoints) {
      if (width >= bp && breakpoints[bp]?.items != null) {
        items = breakpoints[bp].items;
      }
    }

    return items;
  }

  prev(): void {
    this.owlCar?.prev();
    this.currentIndex = Math.max(this.currentIndex - 1, 0);
    this.updateNavigationButtons();
  }

  next(): void {
    this.owlCar?.next();
    this.currentIndex = Math.min(this.currentIndex + 1, this.len - 1);
    this.updateNavigationButtons();
  }

  updateNavigationButtons(): void {
    const itemsPerPage = this.getItemsPerPage();
    this.showArrowLeft = this.currentIndex > 1;
    this.showArrowRight = this.currentIndex * itemsPerPage < this.len;
  }
}
